import api from '../../../shared/utils/api';
import type { Recommendation, RecommendationsData, RecommendationStatus } from '../types/recommendations';

export const getRecommendations = async (tenantId: string): Promise<RecommendationsData> => {
  const { data } = await api.get<RecommendationsData>(`/tenants/${tenantId}/recommendations`);
  return data;
};

export const refreshRecommendations = async (tenantId: string): Promise<RecommendationsData> => {
  const { data } = await api.post<RecommendationsData>(
    `/tenants/${tenantId}/recommendations/refresh`,
  );
  return data;
};

export const updateRecommendationStatus = async (
  tenantId: string,
  recId: number,
  status: RecommendationStatus,
): Promise<Recommendation> => {
  const { data } = await api.patch<Recommendation>(
    `/tenants/${tenantId}/recommendations/${recId}`,
    { status },
  );
  return data;
};
